import {
  DELETE_ACCESS_FAILURE,
  DELETE_ACCESS_LOADING,
  DELETE_ACCESS_SUCCESS,
  FETCH_ACCESS_FAILURE,
  FETCH_ACCESS_LOADING,
  FETCH_ACCESS_SUCCESS
} from '@/Types/accessTypes';
import {
  ADD_ZONE_ERROR,
  ADD_ZONE_LOADING,
  DELETE_ZONE_ERROR,
  DELETE_ZONE_LOADING,
  FETCH_BY_ID_ZONE_ERROR,
  FETCH_BY_ID_ZONE_LOADING,
  FETCH_BY_ID_ZONE_SUCCESS,
  FETCH_ZONE_FAILURE,
  FETCH_ZONE_LOADING,
  FETCH_ZONE_SUCCESS,
  UPDATE_ZONE_ERROR,
  UPDATE_ZONE_LOADING
} from '../Types/zoneTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getZones = () => {
  return dispatch => {
    dispatch({
      type: FETCH_ZONE_LOADING
    });
    api
      .get(`${API_WP}Zone`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ZONE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ZONE_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const getZoneByID = id => {
  return dispatch => {
    dispatch({
      type: FETCH_BY_ID_ZONE_LOADING
    });
    api
      .get(`${API_WP}Zone/search/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_BY_ID_ZONE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_BY_ID_ZONE_ERROR,
          payload: errorMsg
        });
      });
  };
};

export const getZonesByFloor = id => {
  console.log('id', id);
  return dispatch => {
    dispatch({
      type: FETCH_ZONE_LOADING
    });
    api
      .get(`${API_WP}Zone/byFloor/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ZONE_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ZONE_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const addZone = data => {
  const floorId = data.floor._id;
  console.log(data, 'floorId', floorId);
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADD_ZONE_LOADING
      });
      api
        .post(`${API_WP}Zone/add`, data)
        .then(response => {
          const { data } = response.data;
          dispatch(getZonesByFloor(floorId));
          resolve({ status: 200, data: data });
        })
        .catch(error => {
          const errorMsg = error.message;
          dispatch({
            type: ADD_ZONE_ERROR,
            payload: errorMsg
          });
          reject(errorMsg);
        });
    });
  };
};

export const updateZone = (floorId, data) => {
  const zoneId = data.id;
  console.log(data, 'zoneId', zoneId);
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: UPDATE_ZONE_LOADING
      });
      api
        .put(`${API_WP}Zone/update/${zoneId}`, data)
        .then(response => {
          const { data } = response.data;
          dispatch(getZonesByFloor(floorId));
          resolve({ status: 200, data: data });
        })
        .catch(error => {
          const errorMsg = error.message;
          dispatch({
            type: UPDATE_ZONE_ERROR,
            payload: errorMsg
          });
          reject(errorMsg);
        });
    });
  };
};

export const removeZone = (floorId, zoneId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DELETE_ZONE_LOADING
      });
      api
        .delete(`${API_WP}Zone/remove/${zoneId}`)
        .then(response => {
          const { data } = response.data;
          dispatch(getZonesByFloor(floorId));
          resolve({ status: 200, data: data });
        })
        .catch(error => {
          const errorMsg = error.message;
          dispatch({
            type: DELETE_ZONE_ERROR,
            payload: errorMsg
          });
          reject(errorMsg);
        });
    });
  };
};

export const getAccessByZone = id => {
  return dispatch => {
    dispatch({
      type: FETCH_ACCESS_LOADING
    });
    api
      .get(`${API_WP}Zone/accessByZone/${id}`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_ACCESS_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_ACCESS_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const removeAccessess = ids => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DELETE_ACCESS_LOADING
      });
      api
        .post(`${API_WP}Zone/removeAccesses`, { ids })
        .then(() => {
          dispatch({
            type: DELETE_ACCESS_SUCCESS,
            payload: ids
          });
          resolve({ status: 200 });
        })
        .catch(error => {
          const errorMsg = error.message;
          dispatch({
            type: DELETE_ACCESS_FAILURE,
            payload: errorMsg
          });
          reject(error.message);
        });
    });
  };
};
